import { AMZ_SCOPE_REQUEST_NAME } from '../constants';
import { IStorageSessionCredentials } from '../types';

export function getCredentialsScope(
  credentials: IStorageSessionCredentials,
  dateStamp: string
): string {
  return `${dateStamp}/${credentials.region}/${credentials.serviceName}/${AMZ_SCOPE_REQUEST_NAME}`;
}
